import React, { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react-lite';
// import YouTube from 'react-youtube';

import Texts from 'react-sdk/Texts';
import PopupsManager from 'react-sdk/PopupsManager';

import AppState, { POPUPS } from '../../../js/AppState';

import SoundPlayer from 'react-sdk/SoundPlayer';

import classes from './PopupVue.module.css';

import clsx from 'clsx';
import Button from '@/components/shared/Button/Button';
import SequenceScenario from '@/js/SequenceScenario';
import WaveSection from '@/components/shared/WaveSection/WaveSection';

import mask from '../../../images/mask.png';
import { FaChevronLeft } from 'react-icons/fa';

const STEPS = {
  INTRO: "INTRO",
  DONE: "DONE"
}

const PopupVue = () => {
  let imgRef = useRef(null)
  let sidePanelRef = useRef(null)

  const [step, setStep] = useState(null)

  const [panelTranslate, setPanelTranslate] = useState(null)

  const [intro, setIntro] = useState(false)
  const [exited, setExited] = useState(false)
  const [datas, setDatas] = useState(null)

  const [showhud, setShowHud] = useState(false);
  const [animated, setAnimated] = useState(true);

  useEffect(() => {
    setDatas(PopupsManager.getData(POPUPS.LOCATION))
    return (() => {
      if (AppState.debugMode) {
        window.removeEventListener('keydown', (e) => handleKeyPress(e));
      }
    })
  }, []);

  useEffect(() => {
    if (showhud) {
      let timer = setTimeout(() => setShowHud(false), 2200)
      return () => clearTimeout(timer)
    }
  }, [showhud]);

  useEffect(() => {

  }, [step])

  useEffect(() => {
    if (datas) {

      setStep(STEPS.DONE)
      setTimeout(() => {
        setIntro(true)
      }, 70)
    }
  }, [datas])

  function onCloseBtn() {
    if (exited) return

    // AppState.lockInteraction = true
    setExited(true)
    SequenceScenario.playSequence("MainSequence", `dis_${datas["id"]}_close`)
  }
  return (
    <div className={`${classes.PopupVue} ${intro ? classes.intro : ""} ${AppState.selection ? classes.selection : ""}`}>
      {/* <Button
      icon={<FaChevronLeft />}
      className={classes.closeBtn}
      onClick={onCloseBtn} /> */}

      {datas &&
        <div className={classes.content} >
          <div className={classes.illuCntr}>
            <div className={classes.illuMask}>
              <img className={classes.illustration} src={datas["illustration"]} draggable={false} />
            </div>
            <img className={classes.pastille} src={datas["pastille"]} draggable={false} />
          </div>

          <div className={clsx(classes.sidePanel, { intro })} ref={sidePanelRef}>
            <h1 className={classes.title}>{datas && datas["title"]}</h1>
            <div className={classes.infos} >
              <div className={classes.mainInfos} dangerouslySetInnerHTML={{ __html: datas["description"] }} />
              <div className={classes.factsList}>
                {
                  datas["facts"]?.split(';').map((fact, i) => <Fact key={i} title={fact.split(':')[0]} value={fact.split(':')[1]} />)
                }
              </div>
            </div>
          </div>
        </div>}

      <Button className={ classes.continueBtn } onClick={onCloseBtn}>Continuer</Button>

    </div>
  );
};

const Fact = ({ title, value }) => {
  return (
    <div className={classes.fact}>
      <h1>{title}</h1>
      <h2 dangerouslySetInnerHTML={{ __html: value }} />
    </div>
  )
}

export default observer(PopupVue)